/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { RecordForDashboardResponse } from '../models/RecordForDashboardResponse';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class DashboardService {
  constructor(public readonly httpRequest: BaseHttpRequest) {}

  /**
   * List Record For Dashboard Items
   * @param slug
   * @param startDate 조회 시작 날짜 (YYYY-MM-DD)
   * @param endDate 조회 종료 날짜 (YYYY-MM-DD)
   * @returns RecordForDashboardResponse Successful Response
   * @throws ApiError
   */
  public listRecordForDashboardItemsV1WorkspacesSlugDashboardRecordsGet(
    slug: string,
    startDate?: string | null,
    endDate?: string | null
  ): CancelablePromise<RecordForDashboardResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/v1/workspaces/{slug}/dashboard/records',
      path: {
        slug: slug,
      },
      query: {
        start_date: startDate,
        end_date: endDate,
      },
      errors: {
        401: `Unauthorized`,
        403: `Insufficient privileges`,
        422: `Validation Error`,
      },
    });
  }

  /**
   * List Record For Dashboard Items
   * @param slug
   * @param startDate 조회 시작 날짜 (YYYY-MM-DD)
   * @param endDate 조회 종료 날짜 (YYYY-MM-DD)
   * @returns RecordForDashboardResponse Successful Response
   * @throws ApiError
   */
  public listRecordForDashboardItemsDashboardRecordsGet(
    slug: string,
    startDate?: string | null,
    endDate?: string | null
  ): CancelablePromise<RecordForDashboardResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/dashboard/records',
      path: {
        slug: slug,
      },
      query: {
        start_date: startDate,
        end_date: endDate,
      },
      errors: {
        401: `Unauthorized`,
        403: `Insufficient privileges`,
        422: `Validation Error`,
      },
    });
  }
}
